import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	search: {
		alignItems: "center",
		cursor: "pointer",
		display: "flex",
		justifyContent: "center",
		height: 32,
		width: 32
	}
}));

export default styles;
